import { render, staticRenderFns } from "./deleteZoneButtonAndModal.vue?vue&type=template&id=10baf615&"
import script from "./deleteZoneButtonAndModal.vue?vue&type=script&lang=js&"
export * from "./deleteZoneButtonAndModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports